import {} from 'graphql-schema';
import moment, {} from 'moment';
import { DayToNum } from '../../utils/day-of-week-helpers.js';
export const formatDiscoverRentalSportsWhere = ({ dateLow, dateHigh, timeLow, timeHigh, organizationId, organizationName, selectedVenueIds: venueIds, selectedDaysOfWeek: daysOfWeek, selectedSportNames: sportNames, selectedNeighborhoodIds: neighborhoodIds, }) => {
    const timeLowStr = timeLow
        ? moment().startOf('day').add(timeLow, 'minutes').format('HH:mm')
        : null;
    const timeHighStr = timeHigh
        ? moment().startOf('day').add(timeHigh, 'minutes').format('HH:mm')
        : null;
    return {
        is_discoverable: { _eq: true },
        ...(organizationId ? { organization: { _eq: organizationId } } : {}),
        ...(organizationName
            ? { organizationByOrganization: { name: { _eq: organizationName } } }
            : {}),
        ...(venueIds?.length ? { venue: { _in: venueIds } } : {}),
        ...(neighborhoodIds?.length
            ? {
                venueByVenue: {
                    neighborhood_id: {
                        _in: neighborhoodIds,
                    },
                },
            }
            : {}),
        ...(sportNames?.length
            ? {
                sportBySport: {
                    name: { _in: sportNames },
                },
            }
            : {}),
        timeslots: {
            reservation: { _is_null: true },
            start_time: {
                _gte: moment(dateLow || undefined)
                    .startOf('day')
                    .toISOString(),
                ...(dateHigh ? { _lte: moment(dateHigh).endOf('day').toISOString() } : {}),
            },
            ...(daysOfWeek?.length
                ? {
                    day_of_week: {
                        _in: daysOfWeek.map(d => DayToNum[d]),
                    },
                }
                : {}),
            ...(timeLowStr || timeHighStr
                ? {
                    start_time_str: {
                        ...(timeLowStr ? { _gte: timeLowStr } : {}),
                        ...(timeHighStr ? { _lte: timeHighStr } : {}),
                    },
                }
                : {}),
        },
    };
};
export const formatDiscoverRentalVenuesWhere = ({ dateLow, dateHigh, timeLow, timeHigh, organizationId, selectedVenueIds: venueIds, selectedDaysOfWeek: daysOfWeek, selectedSportNames: sportNames, selectedNeighborhoodIds: neighborhoodIds, }) => {
    const timeLowStr = timeLow
        ? moment().startOf('day').add(timeLow, 'minutes').format('HH:mm')
        : null;
    const timeHighStr = timeHigh
        ? moment().startOf('day').add(timeHigh, 'minutes').format('HH:mm')
        : null;
    return {
        disabled: { _eq: false },
        organization: { _eq: organizationId },
        ...(venueIds?.length
            ? {
                _id: { _in: venueIds },
            }
            : {}),
        ...(neighborhoodIds?.length
            ? {
                neighborhood_id: {
                    _in: neighborhoodIds,
                },
            }
            : {}),
        rentals: {
            is_discoverable: { _eq: true },
            ...(sportNames?.length
                ? {
                    sportBySport: {
                        name: { _in: sportNames },
                    },
                }
                : {}),
            timeslots: {
                reservation: { _is_null: true },
                start_time: {
                    _gte: moment(dateLow || undefined)
                        .startOf('day')
                        .toISOString(),
                    ...(dateHigh ? { _lte: moment(dateHigh).endOf('day').toISOString() } : {}),
                },
                ...(daysOfWeek?.length
                    ? {
                        day_of_week: {
                            _in: daysOfWeek.map(d => DayToNum[d]),
                        },
                    }
                    : {}),
                ...(timeLowStr || timeHighStr
                    ? {
                        start_time_str: {
                            ...(timeLowStr ? { _gte: timeLowStr } : {}),
                            ...(timeHighStr ? { _lte: timeHighStr } : {}),
                        },
                    }
                    : {}),
            },
        },
    };
};
